export default {
  primaryColor: '#00d3de',
  secondaryColor: '#ec1c24'
}